import { ScreenLoading } from '@ui-components/neo.tax';
import React, { Suspense } from 'react';

export const createLazyComponent = (
  factory: () => Promise<{ default: () => React.ReactElement }>,
  componentName: string,
): (() => React.ReactElement) => {
  const LazyComponent = React.lazy(factory);

  const SuspenseWrappedComponent = (): React.ReactElement => (
    <Suspense fallback={<ScreenLoading />}>
      <LazyComponent />
    </Suspense>
  );
  SuspenseWrappedComponent.displayName = componentName;
  return SuspenseWrappedComponent;
};
